import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateCustomRules = document.createElement('template');

templateCustomRules.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper d-flex flex-column">
    <header class='page__header'>
       <gz-title class="title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}"></gz-title>
    </header>

    <gz-grid-view hasSelectableRows showGlobalActions>

        <div class="controls-header d-flex justify-center" slot="grid-header-actions-slot">
            <gz-button id="addButton" enabled ></gz-button>

            <gz-select id="changeStatusSelect">
                <gz-button id="changeStatusButton" class="action-button ml-2" type="quiet" color="secondary">
                    <span id="changeStatusText" data-actions class="action-button-text"></span>
                    <span class="action-icon ds-icon-dropdown_arrow"></span>
                </gz-button>
            </gz-select>

            <gz-button id="deleteButton" class="ml-2" color="negative" type="outline"></gz-button>

        </div>

        <div slot="no-results--additional-data">
            <gz-text id="customRulesAdditionalText" class="pb-2" fontSize="14"></gz-text>
            <gz-button id="addButtonEmptyState" enabled></gz-button>
        </div>

    </gz-grid-view>

    <gz-side-menu id="sideMenu" menuwidth="400" closeOnClickOutside resizable="left"></gz-side-menu>
  </div>
`;
